import options from './list.component';

export default {
    selector: 'dtSensorListContainer',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/list/index.js